<template>
  <div class="sectionBox">
    <div class="legendBox" :class="popFlag?'hideScroll':''" :style="{ backgroundImage: 'url(' + bg1 + ')' }">
      <p class="tipsBox">
        <span class="tips" @click="popFlag = true"></span>
      </p>
      <p class="urlBtnBox" @click="urlBtn"></p>
    </div>
    <div class="tipsPopBox" v-if="popFlag" @click.self="popFlag = false">
      <img :src="pop1" alt="">
      <span class="closeBtn" @click="popFlag = false"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      userInfo: [],
      bg1:'',
      pop1:'',
      popFlag: false
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "en") {
        this.$i18n.locale = "en";
        this.bg1 = require("../../assets/legend/bgEn.png");
        this.pop1 = require("../../assets/legend/popEn.png");
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.bg1 = require("../../assets/legend/bgAr.png");
        this.pop1 = require("../../assets/legend/popAr.png");
      } else {
        this.bg1 = require("../../assets/legend/bgEn.png");
        this.pop1 = require("../../assets/legend/popEn.png");
      }
      document.title = this.$t("legend.title");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    urlBtn() {
      window.location.href = "https://cuu3c6o2nu.feishu.cn/wiki/RWjyw5m4fijqHEkrU25cz09qnNg?renamingWikiNode=false&sheet=6yg4Cz"
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.legendBox{
  width: 100%;
  height: 61.4rem;
  background-size: 100% 61.4rem;
  background-repeat: no-repeat;
}
.hideScroll{
  height: 21rem;
}
.tipsBox{
  height: 0.3rem;
  padding-top: 0.7rem;
}
.tipsBox span{
    float: right;
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 0.2rem;
  }
.tipsPopBox{
  width: 100%;
  position: absolute;
  height: 21rem;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
  
}
.tipsPopBox img{
    width: 6.4rem;
    height: 15rem;
    position: absolute;
    top: 3.48rem;
    left: 0;
    /* transform: translateY(-50%); */
  }
.urlBtnBox{
  width: 4.5rem;
  height: 0.5rem;
  margin: 0 auto;
  opacity: 0.5;
  margin-top: 1rem;
}
.sectionBox{
  position: relative;
}
.closeBtn{
  width:0.52rem;
  height: 0.52rem;
  background-image: url("../../assets/legend/close.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 2.9rem;
  right: 0.16rem;
}
</style>
